import { toast } from "sonner";

// Robust clipboard copy that works in preview iframes, http contexts,
// and older browsers where navigator.clipboard is unavailable.
// Falls back to a hidden textarea + document.execCommand("copy"), and
// finally a prompt() so the user can copy manually.
export async function copyToClipboard(text, label = "Copied") {
  if (!text) return false;

  // 1) Modern Async Clipboard API (only works on secure contexts AND
  // when the iframe sandbox / Permissions-Policy allows it).
  try {
    if (typeof navigator !== "undefined" && navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      toast.success(label);
      return true;
    }
  } catch {
    // fall through to fallback
  }

  // 2) Legacy execCommand fallback
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "0";
    ta.style.left = "0";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    if (ok) {
      toast.success(label);
      return true;
    }
  } catch {
    // fall through to prompt
  }

  // 3) Last resort — give the user the text in a prompt so they can copy by hand.
  try {
    // eslint-disable-next-line no-alert
    window.prompt("Press Ctrl/Cmd + C to copy this link:", text);
    return true;
  } catch {
    toast.error("Could not copy — please copy manually");
    return false;
  }
}
